import { concatenar } from './concatenar.js'

export const funcionesPersonalizadas = {
  concatenar,
}
